/* globals $:true */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Alert } from './alerts'

class NudgeBar extends Component {
  componentDidMount() {
    if (this.props.animated) {
      this.handleHide()
    }

    if (this.props.show) {
      this.handleShow()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.show && !this.props.show) {
      this.handleHide()
    }
  }

  componentWillUpdate(nextProps, prevState) {
    if (!this.props.show && nextProps.show) {
      this.handleShow()
    }
  }

  render() {
    const {
      animated,
      children,
      className,
      color,
      contentWrapperClassName,
      onDismiss,
      show,
    } = this.props

    let styles = {
      backgroundColor: color,
      overflow: 'hidden',
      width: '100%',
    }

    if (show || animated) {
      return (
        <div
          className={classNames(className, 'nudge-bar')}
          ref={(c) => (this._el = c)}
          style={styles}
        >
          <Alert
            className={contentWrapperClassName}
            onDismiss={onDismiss ? this.handleDismiss.bind(this) : null}
          >
            {children}
          </Alert>
        </div>
      )
    } else {
      return null
    }
  }

  handleDismiss() {
    this.props.onDismiss && this.props.onDismiss()
    this.handleHide()
  }

  handleShow() {
    if (this.props.animated) {
      setTimeout(() => {
        $('div#content-wrapper').css({
          'margin-top': 0,
          transition: 'margin-top 0.5s',
        })
      }, this.props.delayBeforeAnimation)
    }
  }

  handleHide() {
    $('div#content-wrapper').css({
      'margin-top': `-${this.getHeight()}px`,
    })
  }

  getHeight() {
    return this._el.offsetHeight
  }
}

NudgeBar.propTypes = {
  animated: PropTypes.bool,
  delayBeforeAnimation: PropTypes.number,
  className: PropTypes.string,
  color: PropTypes.string,
  contentWrapperClassName: PropTypes.string,
  dismissable: PropTypes.bool,
  height: PropTypes.number,
  show: PropTypes.bool,
}

NudgeBar.defaultProps = {
  animated: false,
  delayBeforeAnimation: 3000,
  color: '#037695',
  dismissable: false,
  show: true,
}

export default NudgeBar
